import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { getHomeLocation } from 'selectors/navigation/mainNav';
import { isBlankRoute } from 'utils/navigation';

export default function useDefaultRoute() {
  const defaultRoute = useSelector(getHomeLocation);
  return (
    <Route
      component={() => (isBlankRoute() ? <Redirect to={defaultRoute} /> : null)}
    />
  );
}
